import styled from "styled-components";
import {LobbyHeaderDefaultBox} from "./lobby-header.default.box";

export const LobbyHeaderCasino777Box = styled(LobbyHeaderDefaultBox)`
  padding-bottom: 0;
  background-image: url(${props => props.theme.images.texture.toString()});

  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    background-image: url(${props => props.theme.images.texture.toString()});
  }
`;
